import React from 'react'
import Portal from '../Portal/Portal'
import Overlay from '../Overlay/Overlay'
import CleverAlphaButton from '../CleverAlphaButton/CleverAlphaButton'
import { adminResetPortfolioFees } from '../SA_UserPortfolios/actions'

const RenderEditModal = ({ isOpen, closeModal, columnLabel, columnName, accountNumber, name, token, accountIndex, username, component, setUnitSymbol }) => {

    const handleReset = async () => {
        try {
            const fees = { [columnName]: true }
            const response = await adminResetPortfolioFees(token, accountIndex, username, fees);
            if(response.status !== 'OK') {
                throw new Error(response);
            }
            setUnitSymbol('bp');
        } catch (error) {
            console.log(error);
        } finally {
            closeModal();
            component.maybeLoad(true);
        }
    }

    if(!isOpen) {
        return null;
    }

    return (
        <Portal>
            <Overlay>
                <div style={{ backgroundColor: "#fff", padding: '24px'}}>
                    <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{`Reset ${columnLabel} to default values?`}</div>
                    <div style={{ fontSize: '14px', marginTop: '8px'}}>{`${accountNumber} ${name}`}</div>
                    <div style={{ display: 'flex', gap: '16px', marginTop: '24px'}}>
                        <CleverAlphaButton onClick={() => closeModal()}>Cancel</CleverAlphaButton>
                        <CleverAlphaButton onClick={handleReset}>Reset</CleverAlphaButton>
                    </div>
                </div>
            </Overlay>
        </Portal>
    )
}

export default RenderEditModal